import React, { useEffect, useCallback } from "react";
import { Container } from "reactstrap";
import withRouter from '../Common/withRouter';
import { useLayout } from "../../hooks/useLayout";

// Layout Related Components
import NeoHeader from "./NeoHeader";
import NeoSidebar from "./NeoSidebar";

const Layout = (props) => {
  const { sidebarOpen, setSidebarOpen } = useLayout();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isMobile = useCallback(() => window.innerWidth < 992, []);

  useEffect(() => {
    // Aplicar classes no body dependendo do estado do sidebar
    if (sidebarOpen) {
      document.body.classList.add("sidebar-enable");
      if (!isMobile()) {
        document.body.classList.remove("vertical-collpsed");
      }
    } else {
      document.body.classList.remove("sidebar-enable");
      if (!isMobile()) {
        document.body.classList.add("vertical-collpsed");
      }
    }
  }, [sidebarOpen, isMobile]);

  const handleOverlayClick = () => {
    setSidebarOpen(false);
  };

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <NeoHeader />
        <NeoSidebar />
        {/* Mobile overlay — fecha o sidebar ao tocar fora */}
        <div className="neo-sidebar-overlay" onClick={handleOverlayClick} />
        <div className="main-content">
          <div className="page-content">
            <Container fluid>
              {props.children}
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Layout);
